import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  DEPARTMENTSUSERS,
  LEAVECREATE,
  LEAVES_HELPER,
  RECENTAPPROVED,
  USER_LEAVECREATE,
  USER_LEAVES_HELPER,
  USER_MYLEAVE,
  USER_RECENTAPPROVED,
} from "../../service/apiUrl";
import { STRING } from "../../constants/string";
import Utils from "../../utility/utility";
import DateField from "../../components/DateField";
import TimeField from "../../components/TimeField";
import DataTable from "../../components/table/DataTable";
import { postApiCall } from "../../service/PostApiCall";
import moment from "moment";
import { publicHolidayList } from "../../constants/publicHoliday";
import { calculateSandwichLeaves } from "../../constants/sandwichRuleConstant";
import { isWorkingSaturday } from "../../utility/isDateRangeInFirstWeekWithSaturday";
import LoadingButton from "../../components/LoadingButton";
import Banner, { BannerDescription, BannerTitle } from "../../components/Banner";
import { shortLeaveInMonth } from "./leaveTone";

const FieldError = ({ msg }) => (
  <span className={"field-error" + (msg ? " is-shown" : "")}>{msg || ""}</span>
);

const AddDeveloperLeave = (props) => {
  const [errors, setErrors] = useState({});
  const [departmentval, setdepartmentval] = useState();
  const [leavetable, setleavetable] = useState([]);
  const [employee, setEmployee] = useState(false);
  const [departmentEmployees, setdepartmentEmployees] = useState(false);
  const [type, settype] = useState();
  const [fromDate, setfromDate] = useState(new Date());
  const fromDates = Utils.momentDate(fromDate, STRING.SLASH_DATE_FORMAT);
  let [toDate, settoDate] = useState(new Date());
  let toDates = Utils.momentDate(toDate, STRING.SLASH_DATE_FORMAT);
  const [reason, setReason] = useState();
  const [contact, setcontact] = useState();
  const [startTime, setStartTime] = useState("09:00:00");
  const [employes, setEmployes] = useState();
  const [endtime, setEndTime] = useState("09:00:00");
  const [half, setHalf] = useState();
  const [helperData, setHelperData] = useState([]);
  const [hasAlreadyTakenShortLeave, setTakenShortLeave] = useState(false);
  const [isSandwichLeave, setSandwichLeave] = useState(false);
  const [isAlreadyTakeSortLeave, setIsAlreadyTakeShortLeave] = useState(false);
  const [sandwichLeaveType, setSandwichLeaveType] = useState("");
  let [errorMessage, setErrorMessage] = useState("");
  let [dynamicMessage,setDynamicMessage]  = useState("");
  const [dayCount, setDayCount] = useState(0);
  const [myLeaves, setMyLeaves] = useState([]);

  /* Read-only summary card: no search, no facets, no paging — just the four
     columns the old hand-rolled <table> had, so DataTable's own empty state
     replaces the detached "No Recent Approved Leaves" block underneath it.
     enableHiding:false on every column is what keeps the toolbar away:
     DataTable shows the View menu whenever ANY column can be hidden, and a
     three-row read-only card has nothing to toggle or sort. */
  const recentLeaveColumns = React.useMemo(
    () => [
      {
        accessorKey: "from",
        enableSorting: false,
        enableHiding: false,
        header: "Date",
        meta: { className: "text-center" },
        cell: ({ row }) => (
          <span className="text-nowrap">
            {Utils.momentDate(row.original?.from, "MMMM DD, YYYY")}
          </span>
        ),
      },
      {
        accessorKey: "type",
        enableSorting: false,
        enableHiding: false,
        header: "Type",
        meta: { className: "text-center" },
        cell: ({ row }) => (
          <span className="text-nowrap">{row.original?.type}</span>
        ),
      },
      {
        accessorKey: "duration",
        enableSorting: false,
        enableHiding: false,
        header: "Duration",
        meta: { className: "text-center" },
        cell: ({ row }) => (
          <span className="text-nowrap">{row.original?.duration}</span>
        ),
      },
      {
        accessorKey: "reason",
        enableSorting: false,
        enableHiding: false,
        header: "Reason",
        meta: { className: "text-center" },
        cell: ({ row }) => (
          <span title={row.original?.reason}>
            {Utils.stringReducer(row.original?.reason)}
          </span>
        ),
      },
    ],
    []
  );

  const navigate = useNavigate();

  const signdata = useSelector((state) => state.signinReducers);
  const user_id = signdata?.data?.id;
  const access_token = signdata?.data?.access_token;
  useEffect(() => {
    getLeaves();
  }, []);

  const getLeaves = () => {
    const parms = {};
    postApiCall(parms, access_token, USER_MYLEAVE)
      .then((response) => {
        setMyLeaves(response.leaves);
      })
      .catch((error) => {
        console.error("MY_LEAVE", error);
      });
  };

  useEffect(() => {
    postApiCall([], access_token, USER_LEAVES_HELPER)
      .then((result) => {
        setHelperData(result);
      })
      .catch((error) => {
        console.error("LEAVES_HELPER", error);
      });
    getRecentLeaves();
  }, []);

  //  useEffect(() => {
  //   if (!myLeaves || !Array.isArray(myLeaves)) return;

  //   if(type !== 3) return;
  //   console.log(type)
  //   const hasPendingShortLeaveThisMonth = myLeaves.some((leave) => {
  //     const createdAt = moment(Number(leave.created_at) * 1000);
  //     const currentMonth = moment().month();
  //     const currentYear = moment().year();

  //     if (!createdAt.isValid()) {
  //       console.warn("Invalid created_at:", leave.created_at);
  //       return false;
  //     }

  //     return (
  //       leave.type?.startsWith("Short Leave") &&
  //       leave.status === "Pending" &&
  //       createdAt.month() === currentMonth &&
  //       createdAt.year() === currentYear
  //     );
  //   });

  //   setIsAlreadyTakeShortLeave(hasPendingShortLeaveThisMonth);
  // }, [type,myLeaves]);

  function timeToSeconds(timeString) {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  function validateTimeDifference(timeFrom, timeTo) {
    const secondsFromMidnightTimeFrom = timeToSeconds(timeFrom);

    const secondsFromMidnightTimeTo = timeToSeconds(timeTo);
    const timeDifferenceInSeconds =
      secondsFromMidnightTimeTo - secondsFromMidnightTimeFrom;
    const timeDifferenceInHours = timeDifferenceInSeconds / 3600;

    return timeDifferenceInHours;
  }

  const AddLeave = () => {
    let message = "";
        const e = {};
    if (Utils.isEmpty(type)) e.type = STRING.TYPE;
    if (Utils.isTimeAfter(startTime, endtime) && type == 3)
      e.startTime = STRING.TIMEGREATHER;
    if (Utils.isEmpty(reason)) e.reason = STRING.REASON;
    if (Utils.isEmpty(contact)) e.contact = STRING.CONTACT;
    setErrors(e);
    message = Object.keys(e).length ? "invalid" : "";


    if (message) {
      return false;
    } else {
      const addLeaveParams = {
        // department: departmentval,
        type: type,
        from: fromDates,
        /* Only a Full day leave (type 1) renders an End Date field, so `toDate`
           is meaningless for Half day (2) and Short Leave (3) — it sits at its
           `new Date()` initial value and a From Date of tomorrow then trips the
           "From Date cannot be after To Date" guard below. A single-day leave
           ends on the day it starts. */
        to: +type === 1 ? toDates : fromDates,
        half_day: String(half ?? ""),
        time_from: startTime,
        time_to: endtime,
        reason: reason,
        contact: contact,
        isSandwichLeave: isSandwichLeave,
        // created_by: user_id,
        // uid: employes,
      };

      if (+type === 1 && isSandwichLeave === true) {
        addLeaveParams.isSandwichLeave = isSandwichLeave;
      }

      // if (type == 3) {
      //   const isValidTimeDifference = validateTimeDifference(
      //     addLeaveParams.time_from,
      //     addLeaveParams.time_to
      //   );

      //   if (isValidTimeDifference <= 0 || isValidTimeDifference > 2.5) {
      //     Utils.toast(
      //       "error",
      //       "Short leave limited to 2.5 hours. Please adjust the duration"
      //     );
      //     return;
      //   }
      //   console.log("===>sd", myLeaves);

      //   const hasShortLeaveThisMonth = myLeaves.some((leave) => {
      //     if (!leave.created_at) return false;
        
      //     const createdAt = moment(Number(leave.created_at) * 1000); // Convert seconds to ms
      //     if (!createdAt.isValid()) {
      //       console.warn("Invalid created_at:", leave.created_at);
      //       return false;
      //     }
        
      //     const now = moment();
      //     const isSameMonth = createdAt.month() === now.month();
      //     const isSameYear = createdAt.year() === now.year();
        
      //     return (
      //       leave.type?.startsWith("Short Leave") &&
      //       (leave.status === "Pending" || leave.status === "Approved") &&
      //       isSameMonth &&
      //       isSameYear
      //     );
      //   });
        
      //   console.log('--------------->hasShortLeaveThisMonth',hasShortLeaveThisMonth)
      //   setIsAlreadyTakeShortLeave(hasShortLeaveThisMonth);
      //   Utils.toast(
      //     "error",
      //     "You have already applied for a short leave this month."
      //   );
      //   return;
      // }

      if (type == 3) {
        const isValidTimeDifference = validateTimeDifference(
          addLeaveParams.time_from,
          addLeaveParams.time_to
        );
      
        if (isValidTimeDifference <= 0 || isValidTimeDifference > 2.5) {
          Utils.toast(
            "error",
            "Short leave limited to 2.5 hours. Please adjust the duration"
          );
          return false;
        }
      
        /* One short leave per month, counted by the month the leave falls in
           (the From Date), not the month it was applied in. */
        const leaveMonth = moment(addLeaveParams.from, "MM/DD/YYYY");
        const hasShortLeaveThisMonth = !!shortLeaveInMonth(myLeaves, leaveMonth);

        setIsAlreadyTakeShortLeave(hasShortLeaveThisMonth);
        if (hasShortLeaveThisMonth) {
          Utils.toast(
            "error",
            "You can only take 1 short leave in a month. You already have one in " +
              leaveMonth.format("MMMM") + "."
          );
          return false;
        }
      }
     
     //checking from and to date method are correct.
      const fromDate = moment(addLeaveParams.from, 'MM/DD/YYYY'); 
      const toDate = moment(addLeaveParams.to, 'MM/DD/YYYY');
      
      if (!fromDate.isValid()) {
        Utils.toast("error", `Invalid From Date: ${addLeaveParams.from}`);
        return false;
      } else if (!toDate.isValid()) {
        Utils.toast("error", `Invalid To Date: ${addLeaveParams.to}`);
        return false;
      } else {
      
        if (fromDate.isAfter(toDate)) {
          Utils.toast("error", `From Date cannot be after To Date`);
          return false;
        } else {
          console.log('From Date:', fromDate.format('YYYY-MM-DD'));
          console.log('To Date:', toDate.format('YYYY-MM-DD'));
        }
      }
      return postApiCall(addLeaveParams, access_token, USER_LEAVECREATE, navigate)
        .then((response) => {
          Utils.toast("success", "Leave created successfully!!!");
          navigate("/my-leave");
        })
        .catch((error) => {
          Utils.toast("error", error?.data?.message);
          throw error;
        });
    }
  };

  const getRecentLeaves = () => {
    const params = {};
    postApiCall(params, access_token, USER_RECENTAPPROVED).then((result) => {
      setleavetable(result?.approved_leaves);
    });
  };

  // check user take twice a short leave ?

  // const takeAlreadyShortLeave = () => {
  //   const startOfWeek = moment()
  //     .startOf("week")
  //     .format("MM/DD/YYYY");
  //   const endOfWeek = moment()
  //     .endOf("week")
  //     .format("MM/DD/YYYY");

  //   const weeklyLeaveData = leavetable.filter((leave) =>
  //     moment(leave.from).isBetween(startOfWeek, endOfWeek, "day", "[]")
  //   );

  //   const shortLeaveCount = weeklyLeaveData.filter(
  //     (leave) => leave.type === "Short Leave"
  //   ).length;

  //   if (shortLeaveCount >= 1) {
  //     setTakenShortLeave(true);
  //     return true;
  //   }
  //   setTakenShortLeave(false);
  //   return false;
  // };


// public Holiday List Included.
// const checkForSandwichLeave = () => {
//   let startDate = moment(fromDate, "MM/DD/YYYY");
//   let endDate = moment(toDate, "MM/DD/YYYY");
//   const currentLeaveDaysCount = endDate.diff(startDate, "days") + 1;

//   let dynamicMessage = "";
//   let sandwichApplied = false;

//   // Convert publicHolidayList to a Set of formatted date strings for efficient lookup
//   const publicHolidaySet = new Set(
//     publicHolidayList.map((holiday) =>
//       moment(holiday.date).format("YYYY-MM-DD")
//     )
//   );

//   // Helper function to check if a date is a weekend
//   const isWeekend = (date) => {
//     const day = date.day();
//     return day === 0 || day === 6; // Sunday=0, Saturday=6
//   };

//   // Helper function to check if a date is a public holiday
//   const isPublicHoliday = (date) => {
//     return publicHolidaySet.has(date.format("YYYY-MM-DD"));
//   };

//   // Helper function to check if a date is a non-working day
//   const isNonWorkingDay = (date) => {
//     return isWeekend(date) || isPublicHoliday(date);
//   };

//   // Helper function to check if a leave includes both Friday and Monday
//   const includesFridayAndMonday = (start, end) => {
//     let hasFriday = false;
//     let hasMonday = false;
//     let current = start.clone();
//     while (current.isSameOrBefore(end)) {
//       const day = current.day();
//       if (day === 5) hasFriday = true; // Friday
//       if (day === 1) hasMonday = true; // Monday
//       current.add(1, "day");
//     }
//     return hasFriday && hasMonday;
//   };

//   // Parse leave data
//   const parsedLeaveData = leavetable
//     .filter((leave) => leave.type === "Full day")
//     .map((leave) => {
//       const start = moment(leave.from, "MM/DD/YYYY");
//       const end = leave.to ? moment(leave.to, "MM/DD/YYYY") : start.clone();
//       return { ...leave, start, end };
//     });

//   // Define the range for the last three months
//   const startOfRange = moment().startOf("month").subtract(3, "months");
//   const endOfRange = moment().endOf("month");

//   // Filter past sandwich leaves in the last three months
//   const pastSandwichLeaves = parsedLeaveData.filter((leave) => {
//     const inDateRange =
//       leave.start.isBetween(startOfRange, endOfRange, "day", "[]") ||
//       leave.end.isBetween(startOfRange, endOfRange, "day", "[]");
//     return inDateRange && includesFridayAndMonday(leave.start, leave.end);
//   });

//   // Check if the current leave includes both Friday and Monday
//   const hasFridayAndMonday = includesFridayAndMonday(startDate, endDate);
//   const sandwichFound = pastSandwichLeaves.length > 0;

//   if (hasFridayAndMonday) {
//     if (sandwichFound) {
//       // Mark as sandwich leave
//       setSandwichLeave(true);
//       dynamicMessage = "Your leave includes Friday and Monday and is marked as a sandwich leave.";
//       sandwichApplied = true;
//     } else {
//       setSandwichLeave(false);
//       dynamicMessage = "Your leave includes Friday and Monday but is not marked as a sandwich leave due to no similar leave in the past three months.";
//     }
//   } else if (
//     currentLeaveDaysCount === 1 &&
//     (startDate.day() === 5 || startDate.day() === 1)
//   ) {
//     // Single day leave on Friday or Monday
//     const adjacentDay =
//       startDate.day() === 5
//         ? startDate.clone().add(3, "days") // Check if Monday leave exists
//         : startDate.clone().subtract(3, "days"); // Check if Friday leave exists
  
//     const adjacentLeaveExists = parsedLeaveData.some((leave) => {
//       return (
//         adjacentDay.isSameOrAfter(leave.start, "day") &&
//         adjacentDay.isSameOrBefore(leave.end, "day")
//       );
//     });
  
//     if (adjacentLeaveExists) {
//       // Adjust leave to include sandwich days
//       startDate = startDate.day() === 5 ? startDate.clone().add(1, "days") : startDate.clone().subtract(2, "days");
//       endDate = startDate.clone().add(2, "days");
//       setfromDate(startDate.toDate());
//       settoDate(endDate.toDate());
//       setSandwichLeave(true);
//       dynamicMessage = "Your leave on Friday and Monday is marked as a sandwich leave, including the weekend or public holidays.";
//       sandwichApplied = true;
//     } else {
//       setSandwichLeave(false);
//       dynamicMessage = "Your leave does not qualify as a sandwich leave.";
//     }
//   }
//   else {
//     setSandwichLeave(false);
//     dynamicMessage = "Your leave does not qualify as a sandwich leave.";
//   }

//   console.log("===> Sandwich leave applied: ", sandwichApplied);
//   console.log("===> Dynamic message: ", dynamicMessage);

//   // Set the dynamic message
//   setDynamicMessage(dynamicMessage);
// };
//correct modified method 2
// const checkForSandwichLeave = () => {
//   let startDate = moment(fromDate, "MM/DD/YYYY");
//   let endDate = moment(toDate, "MM/DD/YYYY");
//   const currentLeaveDaysCount = endDate.diff(startDate, "days") + 1;

//   let dynamicMessage = "";
//   let sandwichApplied = false;

//   // Helper to check if date range includes both Friday and Monday
//   const includesFridayAndMonday = (start, end) => {
//     let hasFriday = false;
//     let hasMonday = false;
//     let current = start.clone();
//     while (current.isSameOrBefore(end)) {
//       const day = current.day(); // Sunday = 0, Monday = 1, ..., Friday = 5
//       if (day === 5) hasFriday = true;
//       if (day === 1) hasMonday = true;
//       current.add(1, "day");
//     }
//     return hasFriday && hasMonday;
//   };

//   // Parse historical full-day leaves
//   const parsedLeaveData = leavetable
//     .filter((leave) => leave.type === "Full day")
//     .map((leave) => {
//       const start = moment(leave.from, "MM/DD/YYYY");
//       const end = leave.to ? moment(leave.to, "MM/DD/YYYY") : start.clone();
//       return { ...leave, start, end };
//     });

//   // Define the range for the last three months
//   const startOfRange = moment().startOf("month").subtract(3, "months");
//   const endOfRange = moment().endOf("month");

//   // Filter for past sandwich leaves within the last 3 months
//   const pastSandwichLeaves = parsedLeaveData.filter((leave) => {
//     const inDateRange =
//       leave.start.isBetween(startOfRange, endOfRange, "day", "[]") ||
//       leave.end.isBetween(startOfRange, endOfRange, "day", "[]");
//     return inDateRange && includesFridayAndMonday(leave.start, leave.end);
//   });

//   const hasFridayAndMonday = includesFridayAndMonday(startDate, endDate);
//   const sandwichFound = pastSandwichLeaves.length > 0;

//   if (hasFridayAndMonday) {
//     if (sandwichFound) {
//       let expandedStart = startDate.clone();
//       let expandedEnd = endDate.clone();

//       // Make sure expandedStart is the Friday before the Monday
//       if (startDate.day() === 1 && currentLeaveDaysCount === 1) {
//         // Only Monday selected
//         const fridayLeave = parsedLeaveData.find((leave) =>
//           startDate.clone().subtract(3, "days").isBetween(leave.start, leave.end, "day", "[]")
//         );

//         if (fridayLeave) {
//           expandedStart = startDate.clone().subtract(3, "days");
//           expandedEnd = startDate.clone(); // Monday
//         }
//       }

//       // Only Friday selected
//       if (startDate.day() === 5 && currentLeaveDaysCount === 1) {
//         const mondayLeave = parsedLeaveData.find((leave) =>
//           startDate.clone().add(3, "days").isBetween(leave.start, leave.end, "day", "[]")
//         );

//         if (mondayLeave) {
//           expandedStart = startDate.clone(); // Friday
//           expandedEnd = startDate.clone().add(3, "days"); // Monday
//         }
//       }

//       const expandedStartDate = expandedStart.toDate();
// const expandedEndDate = expandedEnd.toDate();

// if (
//   expandedStartDate.getTime() !== fromDate.getTime() ||
//   expandedEndDate.getTime() !== toDate.getTime()
// ) {
//   setfromDate(expandedStartDate);
//   settoDate(expandedEndDate);
// }


//       setSandwichLeave(true);
//       sandwichApplied = true;
//       dynamicMessage =
//         "Your leave qualifies as a sandwich leave. Days from " +
//         expandedStart.format("MM/DD/YYYY") +
//         " to " +
//         expandedEnd.format("MM/DD/YYYY") +
//         " will be deducted.";
//     } else {
//       setSandwichLeave(false);
//       dynamicMessage =
//         "Your leave includes Friday and Monday but no similar leave found in the past 3 months.";
//     }
//   } else if (
//     currentLeaveDaysCount === 1 &&
//     (startDate.day() === 5 || startDate.day() === 1)
//   ) {
//     // Single-day leave on Friday or Monday
//     const pairedDay =
//       startDate.day() === 5
//         ? startDate.clone().add(3, "days") // Friday → check Monday
//         : startDate.clone().subtract(3, "days"); // Monday → check Friday

//     const adjacentLeaveExists = parsedLeaveData.some((leave) => {
//       return (
//         pairedDay.isSameOrAfter(leave.start, "day") &&
//         pairedDay.isSameOrBefore(leave.end, "day")
//       );
//     });

//     if (adjacentLeaveExists) {
//       const expandedStart = startDate.day() === 5 ? startDate.clone() : startDate.clone().subtract(3, "days");
//       const expandedEnd = startDate.day() === 5 ? startDate.clone().add(3, "days") : startDate.clone();

//       setfromDate(expandedStart.toDate());
//       settoDate(expandedEnd.toDate());

//       setSandwichLeave(true);
//       sandwichApplied = true;
//       dynamicMessage =
//         "Your leave on Friday or Monday forms a sandwich leave. Days from " +
//         expandedStart.format("MM/DD/YYYY") +
//         " to " +
//         expandedEnd.format("MM/DD/YYYY") +
//         " will be deducted.";
//     } else {
//       setSandwichLeave(false);
//       dynamicMessage = "Your leave does not qualify as a sandwich leave.";
//     }
//   } else {
//     setSandwichLeave(false);
//     dynamicMessage = "Your leave does not qualify as a sandwich leave.";
//   }
//   setDynamicMessage(dynamicMessage);
// };
// working for public holiday 

// const checkForSandwichLeave = () => {
//   let startDate = moment(fromDate, "MM/DD/YYYY");
//   let endDate = moment(toDate, "MM/DD/YYYY");
//   const currentLeaveDaysCount = endDate.diff(startDate, "days") + 1;

//   let dynamicMessage = "";
//   let sandwichApplied = false;

//   // Helper to check if date range includes both Friday and Monday
//   const includesFridayAndMonday = (start, end) => {
//     let hasFriday = false;
//     let hasMonday = false;
//     let current = start.clone();
//     while (current.isSameOrBefore(end)) {
//       const day = current.day(); // Sunday = 0, Monday = 1, ..., Friday = 5
//       if (day === 5) hasFriday = true;
//       if (day === 1) hasMonday = true;
//       current.add(1, "day");
//     }
//     return hasFriday && hasMonday;
//   };

//   // Parse historical full-day leaves
//   const parsedLeaveData = leavetable
//     .filter((leave) => leave.type === "Full day")
//     .map((leave) => {
//       const start = moment(leave.from, "MM/DD/YYYY");
//       const end = leave.to ? moment(leave.to, "MM/DD/YYYY") : start.clone();
//       return { ...leave, start, end };
//     });

//   // Define the range for the last three months
//   const startOfRange = moment().startOf("month").subtract(3, "months");
//   const endOfRange = moment().endOf("month");

//   // Filter for past sandwich leaves within the last 3 months
//   const pastSandwichLeaves = parsedLeaveData.filter((leave) => {
//     const inDateRange =
//       leave.start.isBetween(startOfRange, endOfRange, "day", "[]") ||
//       leave.end.isBetween(startOfRange, endOfRange, "day", "[]");
//     return inDateRange && includesFridayAndMonday(leave.start, leave.end);
//   });

//   const hasFridayAndMonday = includesFridayAndMonday(startDate, endDate);
//   const sandwichFound = pastSandwichLeaves.length > 0;
  

//   if (hasFridayAndMonday) {
//     if (sandwichFound) {
//       let expandedStart = startDate.clone();
//       let expandedEnd = endDate.clone();

//       // Make sure expandedStart is the Friday before the Monday
//       if (startDate.day() === 1 && currentLeaveDaysCount === 1) {
//         // Only Monday selected
//         const fridayLeave = parsedLeaveData.find((leave) =>
//           startDate.clone().subtract(3, "days").isBetween(leave.start, leave.end, "day", "[]")
//         );

//         if (fridayLeave) {
//           expandedStart = startDate.clone().subtract(3, "days");
//           expandedEnd = startDate.clone(); // Monday
//         }
//       }

//       // Only Friday selected
//       if (startDate.day() === 5 && currentLeaveDaysCount === 1) {
//         const mondayLeave = parsedLeaveData.find((leave) =>
//           startDate.clone().add(3, "days").isBetween(leave.start, leave.end, "day", "[]")
//         );

//         if (mondayLeave) {
//           expandedStart = startDate.clone(); // Friday
//           expandedEnd = startDate.clone().add(3, "days"); // Monday
//         }
//       }

//       const expandedStartDate = expandedStart.toDate();
// const expandedEndDate = expandedEnd.toDate();

// if (
//   expandedStartDate.getTime() !== fromDate.getTime() ||
//   expandedEndDate.getTime() !== toDate.getTime()
// ) {
//   setfromDate(expandedStartDate);
//   settoDate(expandedEndDate);
// }


//       setSandwichLeave(true);
//       sandwichApplied = true;
//       dynamicMessage =
//         "Your leave qualifies as a sandwich leave. Days from " +
//         expandedStart.format("MM/DD/YYYY") +
//         " to " +
//         expandedEnd.format("MM/DD/YYYY") +
//         " will be deducted.";
//     } else {
//       setSandwichLeave(false);
//       dynamicMessage =
//         "Your leave includes Friday and Monday but no similar leave found in the past 3 months.";
//     }
//   } else if (
//     currentLeaveDaysCount === 1 &&
//     (startDate.day() === 5 || startDate.day() === 1)
//   ) {
//     // Single-day leave on Friday or Monday
//     const pairedDay =
//       startDate.day() === 5
//         ? startDate.clone().add(3, "days") // Friday → check Monday
//         : startDate.clone().subtract(3, "days"); // Monday → check Friday

//     const adjacentLeaveExists = parsedLeaveData.some((leave) => {
//       return (
//         pairedDay.isSameOrAfter(leave.start, "day") &&
//         pairedDay.isSameOrBefore(leave.end, "day")
//       );
//     });

//     if (adjacentLeaveExists) {
//       const expandedStart = startDate.day() === 5 ? startDate.clone() : startDate.clone().subtract(3, "days");
//       const expandedEnd = startDate.day() === 5 ? startDate.clone().add(3, "days") : startDate.clone();

//       setfromDate(expandedStart.toDate());
//       settoDate(expandedEnd.toDate());

//       setSandwichLeave(true);
//       sandwichApplied = true;
//       dynamicMessage =
//         "Your leave on Friday or Monday forms a sandwich leave. Days from " +
//         expandedStart.format("MM/DD/YYYY") +
//         " to " +
//         expandedEnd.format("MM/DD/YYYY") +
//         " will be deducted.";
//     } else {
//       setSandwichLeave(false);
//       dynamicMessage = "Your leave does not qualify as a sandwich leave.";
//     }
//   } else {
//     setSandwichLeave(false);
//    // Calculate total applied leave days
// const totalLeaveDays = endDate.diff(startDate, "days") + 1;
// console.log('--->startDate Difference',totalLeaveDays)

// // Find holidays inside leave range
// const holidaysInRange = publicHolidayList.filter(holiday => {
//   const holidayDate = moment(holiday.date);
//   return holidayDate.isBetween(startDate, endDate, "day", "[]");
// });

// // Check for holiday just before startDate (startDate - 1 day)
// const holidayBefore = publicHolidayList.some((holiday) => {
//   const holidayDate = moment(holiday.date, "MM/DD/YYYY").startOf("day");
//   const target = startDate.clone().subtract(1, "day").startOf("day");
//   return holidayDate.isSame(target, "day");
// });

// const holidayAfter = publicHolidayList.some((holiday) => {
//   const holidayDate = moment(holiday.date, "MM/DD/YYYY").startOf("day");
//   const target = endDate.clone().add(1, "day").startOf("day");
//   return holidayDate.isSame(target, "day");
// });

// console.log('---sadsadsad',totalLeaveDays >= 4 ,
// holidaysInRange.length > 0 
// ,holidayBefore , holidayAfter)
// if (
//   totalLeaveDays >= 4 &&
//   holidaysInRange.length > 0
// ) {
//   console.log('--->condition is true')
//   setSandwichLeave(true);
//   setDynamicMessage(
//     "Your leave qualifies as a sandwich leave because it includes a public holiday and touches a holiday before or after your leave range."
//   );
//   setErrorMessage( "Your leave qualifies as a sandwich leave because it includes a public holiday and touches a holiday before or after your leave range.")
//   dynamicMessage = 'Your leave qualifies as a sandwich leave because it includes a public holiday and touches a holiday before or after your leave range.';
// } else {
//   console.log('sdsd condition is false')
//   setSandwichLeave(false);
//   setDynamicMessage("Your leave does not qualify as a sandwich leave.");
  
// }

//   }
//   setDynamicMessage(dynamicMessage);
// };

/// implement thusday sandwich 
// const checkForSandwichLeave = () => {
//   let startDate = moment(fromDate, "MM/DD/YYYY");
//   let endDate = moment(toDate, "MM/DD/YYYY");
//   const currentLeaveDaysCount = endDate.diff(startDate, "days") + 1;

//   let dynamicMessage = "";
//   let sandwichApplied = false;

//   // Helper: Ignore first Saturdays
//   const isWorkingSaturday = (date) => {
//     return date.day() === 6 && date.date() <= 7;
//   };

//   // Helper: Check if Friday+Monday or Thu+Fri with weekend
//   const includesSandwichPattern = (start, end) => {
//     let hasFriday = false, hasMonday = false, hasThursday = false;
//     let current = start.clone();
//     while (current.isSameOrBefore(end)) {
//       const day = current.day();

//       if (isWorkingSaturday(current)) {
//         current.add(1, "day");
//         continue;
//       }

//       if (day === 4) hasThursday = true;
//       if (day === 5) hasFriday = true;
//       if (day === 1) hasMonday = true;

//       current.add(1, "day");
//     }

//     // Detect Thu+Fri+Sat+Sun combo
//     if (hasThursday && hasFriday) {
//       const saturday = start.clone().day(6);
//       const sunday = start.clone().day(0).add(1, "week");
//       const isWeekendValid = !isWorkingSaturday(saturday);
//       return isWeekendValid;
//     }

//     // Default: Friday + Monday combo
//     return hasFriday && hasMonday;
//   };

//   // Parse previous leave data
//   const parsedLeaveData = leavetable
//     .filter((leave) => leave.type === "Full day")
//     .map((leave) => {
//       const start = moment(leave.from, "MM/DD/YYYY");
//       const end = leave.to ? moment(leave.to, "MM/DD/YYYY") : start.clone();
//       return { ...leave, start, end };
//     });

//   // Sandwich leave in past 3 months
//   const rangeStart = moment().startOf("month").subtract(3, "months");
//   const rangeEnd = moment().endOf("month");

//   const pastSandwichLeaves = parsedLeaveData.filter((leave) => {
//     const inRange =
//       leave.start.isBetween(rangeStart, rangeEnd, "day", "[]") ||
//       leave.end.isBetween(rangeStart, rangeEnd, "day", "[]");
//     return inRange && includesSandwichPattern(leave.start, leave.end);
//   });

//   const matchesSandwich = includesSandwichPattern(startDate, endDate);
//   const sandwichFoundBefore = pastSandwichLeaves.length > 0;

//   if (matchesSandwich) {
//     if (sandwichFoundBefore) {
//       let expandedStart = startDate.clone();
//       let expandedEnd = endDate.clone();

//       if (startDate.day() === 1 && currentLeaveDaysCount === 1) {
//         const fridayLeave = parsedLeaveData.find((leave) =>
//           startDate.clone().subtract(3, "days").isBetween(leave.start, leave.end, "day", "[]")
//         );
//         if (fridayLeave) {
//           expandedStart = startDate.clone().subtract(3, "days");
//           expandedEnd = startDate.clone();
//         }
//       }

//       if (startDate.day() === 5 && currentLeaveDaysCount === 1) {
//         const mondayLeave = parsedLeaveData.find((leave) =>
//           startDate.clone().add(3, "days").isBetween(leave.start, leave.end, "day", "[]")
//         );
//         if (mondayLeave) {
//           expandedStart = startDate.clone();
//           expandedEnd = startDate.clone().add(3, "days");
//         }
//       }

//       // Thu+Fri logic
//       if (startDate.day() === 4 && currentLeaveDaysCount === 2) {
//         const saturday = startDate.clone().add(2, "days");
//         const isSatWorking = isWorkingSaturday(saturday) === false;
//         if (isSatWorking) {
//           expandedStart = startDate.clone();
//           expandedEnd = startDate.clone().add(3, "days");
//         }
//       }

//       if (
//         expandedStart.toDate().getTime() !== fromDate.getTime() ||
//         expandedEnd.toDate().getTime() !== toDate.getTime()
//       ) {
//         setfromDate(expandedStart.toDate());
//         settoDate(expandedEnd.toDate());
//       }

//       setSandwichLeave(true);
//       sandwichApplied = true;
//       dynamicMessage = `Your leave qualifies as a sandwich leave. Days from ${expandedStart.format("MM/DD/YYYY")} to ${expandedEnd.format("MM/DD/YYYY")} will be deducted.`;
//     } else {
//       setSandwichLeave(false);
//       dynamicMessage = "Your leave includes sandwich-like days, but no similar pattern found in the past 3 months.";
//     }
//   } else if (
//     currentLeaveDaysCount === 1 &&
//     (startDate.day() === 5 || startDate.day() === 1)
//   ) {
//     const pairedDay =
//       startDate.day() === 5
//         ? startDate.clone().add(3, "days")
//         : startDate.clone().subtract(3, "days");

//     const adjacentLeaveExists = parsedLeaveData.some((leave) => {
//       return (
//         pairedDay.isSameOrAfter(leave.start, "day") &&
//         pairedDay.isSameOrBefore(leave.end, "day")
//       );
//     });

//     if (adjacentLeaveExists) {
//       const expandedStart = startDate.day() === 5 ? startDate.clone() : startDate.clone().subtract(3, "days");
//       const expandedEnd = startDate.day() === 5 ? startDate.clone().add(3, "days") : startDate.clone();

//       setfromDate(expandedStart.toDate());
//       settoDate(expandedEnd.toDate());

//       setSandwichLeave(true);
//       sandwichApplied = true;
//       dynamicMessage =
//         "Your leave on Friday or Monday forms a sandwich leave. Days from " +
//         expandedStart.format("MM/DD/YYYY") +
//         " to " +
//         expandedEnd.format("MM/DD/YYYY") +
//         " will be deducted.";
//     } else {
//       setSandwichLeave(false);
//       dynamicMessage = "Your leave does not qualify as a sandwich leave.";
//     }
//   } else {
//     setSandwichLeave(false);

//     const holidaysInRange = publicHolidayList.filter((holiday) => {
//       const holidayDate = moment(holiday.date, "MM/DD/YYYY");
//       if (isWorkingSaturday(holidayDate)) return false;
//       return holidayDate.isBetween(startDate, endDate, "day", "[]");
//     });

//     const holidayBefore = publicHolidayList.some((holiday) => {
//       const date = moment(holiday.date, "MM/DD/YYYY").startOf("day");
//       return date.isSame(startDate.clone().subtract(1, "day"), "day");
//     });

//     const holidayAfter = publicHolidayList.some((holiday) => {
//       const date = moment(holiday.date, "MM/DD/YYYY").startOf("day");
//       return date.isSame(endDate.clone().add(1, "day"), "day");
//     });

//     if (
//       currentLeaveDaysCount >= 4 &&
//       holidaysInRange.length > 0 &&
//       (holidayBefore || holidayAfter)
//     ) {
//       setSandwichLeave(true);
//       dynamicMessage =
//         "Your leave qualifies as a sandwich leave due to public holidays connecting your leave.";
//     } else {
//       setSandwichLeave(false);
//       dynamicMessage = "Your leave does not qualify as a sandwich leave.";
//     }
//   }

//   setDynamicMessage(dynamicMessage);
// };

// const checkForSandwichLeave = () => {
//   let startDate = moment(fromDate, "MM/DD/YYYY");
//   let endDate = moment(toDate, "MM/DD/YYYY");
//   const currentLeaveDaysCount = endDate.diff(startDate, "days") + 1;

//   let dynamicMessage = "";
//   let sandwichApplied = false;

//   const isWorkingSaturday = (date) => {
//     return date.day() === 6 && date.date() <= 7;
//   };

//   const includesSandwichPattern = (start, end) => {
//     let hasFriday = false, hasMonday = false, hasThursday = false;
//     let current = start.clone();
//     while (current.isSameOrBefore(end)) {
//       const day = current.day();
//       if (isWorkingSaturday(current)) {
//         current.add(1, "day");
//         continue;
//       }
//       if (day === 4) hasThursday = true;
//       if (day === 5) hasFriday = true;
//       if (day === 1) hasMonday = true;
//       current.add(1, "day");
//     }
//     if (hasThursday && hasFriday) {
//       const saturday = start.clone().day(6);
//       const isWeekendValid = !isWorkingSaturday(saturday);
//       return isWeekendValid;
//     }
//     return hasFriday && hasMonday;
//   };

//   const parsedLeaveData = leavetable
//     .filter((leave) => leave.type === "Full day")
//     .map((leave) => {
//       const start = moment(leave.from, "MM/DD/YYYY");
//       const end = leave.to ? moment(leave.to, "MM/DD/YYYY") : start.clone();
//       return { ...leave, start, end };
//     });

//   const rangeStart = moment().startOf("month").subtract(3, "months");
//   const rangeEnd = moment().endOf("month");

//   const pastSandwichLeaves = parsedLeaveData.filter((leave) => {
//     const inRange =
//       leave.start.isBetween(rangeStart, rangeEnd, "day", "[]") ||
//       leave.end.isBetween(rangeStart, rangeEnd, "day", "[]");
//     return inRange && includesSandwichPattern(leave.start, leave.end);
//   });

//   const matchesSandwich = includesSandwichPattern(startDate, endDate);
//   const sandwichFoundBefore = pastSandwichLeaves.length > 0;

// const startDay = startDate?.day();
// const endDay = endDate?.day();

// console.log('startDay', startDay, 'endDay', endDay);

// // Validate input dates early
// if (!startDate || !endDate || !endDate.isSameOrAfter(startDate, "day")) return;

// // Check preceding weekend
// const precedingSaturday = startDate.clone().subtract(2, "days");
// const precedingSunday = startDate.clone().subtract(1, "days");

// const isFirstSaturday = isWorkingSaturday(precedingSaturday);
// const isWeekendOff = !isFirstSaturday; // Sunday always off

// console.log('--> current LeaveCount', currentLeaveDaysCount);

// // Minimum 2 days leave required to apply sandwich logic
// if (currentLeaveDaysCount <= 1) return;

// // Utility: Apply sandwich leave
// const applySandwichLeave = (fromDate) => {
//   const forcedFrom = fromDate.clone();
//   const forcedTo = forcedFrom.clone().add(3, "days");

//   setfromDate(forcedFrom.toDate());
//   settoDate(forcedTo.toDate());
//   setSandwichLeave(true);
//   sandwichApplied = true;

//   const message = `Your leave overlaps with a weekend. 4 days from ${forcedFrom.format("MM/DD/YYYY")} to ${forcedTo.format("MM/DD/YYYY")} will be deducted as sandwich leave.`;
//   setDynamicMessage(message);
//
// };

// // Check if leave overlaps a weekend (Saturday or Sunday)
// // Check if leave overlaps a weekend (Saturday or Sunday)
// const leaveOverlapsWeekend = [6, 0].some((d) => startDay <= d && endDay >= d);

// if (leaveOverlapsWeekend && isWeekendOff) {
//   const leaveEnclosesWeekend =
//     startDay <= 5 && // Starts on or before Friday
//     endDay >= 1 &&   // Ends on or after Monday
//     startDate.clone().day(6).isBetween(startDate, endDate, null, '[]') &&
//     startDate.clone().day(0).isBetween(startDate, endDate, null, '[]');

//   if (leaveEnclosesWeekend) {
//     // Weekend is sandwiched by leave on both sides
//     applySandwichLeave(startDate);
//   }
// }


//   else if (matchesSandwich) {
//     if (sandwichFoundBefore) {
//       let expandedStart = startDate.clone();
//       let expandedEnd = endDate.clone();

//       if (startDate.day() === 1 && currentLeaveDaysCount === 1) {
//         const fridayLeave = parsedLeaveData.find((leave) =>
//           startDate.clone().subtract(3, "days").isBetween(leave.start, leave.end, "day", "[]")
//         );
//         if (fridayLeave) {
//           expandedStart = startDate.clone().subtract(3, "days");
//           expandedEnd = startDate.clone();
//         }
//       }

//       if (startDate.day() === 5 && currentLeaveDaysCount === 1) {
//         const mondayLeave = parsedLeaveData.find((leave) =>
//           startDate.clone().add(3, "days").isBetween(leave.start, leave.end, "day", "[]")
//         );
//         if (mondayLeave) {
//           expandedStart = startDate.clone();
//           expandedEnd = startDate.clone().add(3, "days");
//         }
//       }

//       if (startDate.day() === 4 && currentLeaveDaysCount === 2) {
//         const saturday = startDate.clone().add(2, "days");
//         const isSatWorking = isWorkingSaturday(saturday) === false;
//         if (isSatWorking) {
//           expandedStart = startDate.clone();
//           expandedEnd = startDate.clone().add(3, "days");
//         }
//       }

//       if (
//         expandedStart.toDate().getTime() !== fromDate.getTime() ||
//         expandedEnd.toDate().getTime() !== toDate.getTime()
//       ) {
//         setfromDate(expandedStart.toDate());
//         settoDate(expandedEnd.toDate());
//       }

//       setSandwichLeave(true);
//       sandwichApplied = true;
//       dynamicMessage = `Your leave qualifies as a sandwich leave. Days from ${expandedStart.format("MM/DD/YYYY")} to ${expandedEnd.format("MM/DD/YYYY")} will be deducted.`;
//     } else {
//       setSandwichLeave(false);
//       dynamicMessage = "Your leave includes sandwich-like days, but no similar pattern found in the past 3 months.";
//     }
//   } 

// else if (
//   startDate.day() === 1 && // Monday
//   currentLeaveDaysCount >= 2 &&
//   precedingSaturday.day() === 6 && // Saturday
//   precedingSunday.day() === 0     // Sunday
// ) {
//   const newFrom = precedingSaturday.clone();
//   const newTo = endDate.clone();

//   setfromDate(newFrom.toDate());
//   settoDate(newTo.toDate());

//   sandwichApplied = true;
//   setSandwichLeave(true);

//   dynamicMessage = `Your leave starting Monday after weekend extends for ${currentLeaveDaysCount} days. Days from ${newFrom.format("MM/DD/YYYY")} to ${newTo.format("MM/DD/YYYY")} will be deducted as sandwich leave.`;
//   setDynamicMessage(dynamicMessage);
//   Utils.toast('error',dynamicMessage)

// }

//    else {
//     setSandwichLeave(false);

//     const holidaysInRange = publicHolidayList.filter((holiday) => {
//       const holidayDate = moment(holiday.date, "MM/DD/YYYY");
//       if (isWorkingSaturday(holidayDate)) return false;
//       return holidayDate.isBetween(startDate, endDate, "day", "[]");
//     });

//     const holidayBefore = publicHolidayList.some((holiday) => {
//       const date = moment(holiday.date, "MM/DD/YYYY").startOf("day");
//       return date.isSame(startDate.clone().subtract(1, "day"), "day");
//     });

//     const holidayAfter = publicHolidayList.some((holiday) => {
//       const date = moment(holiday.date, "MM/DD/YYYY").startOf("day");
//       return date.isSame(endDate.clone().add(1, "day"), "day");
//     });

//     if (
//       currentLeaveDaysCount >= 4 &&
//       holidaysInRange.length > 0 &&
//       (holidayBefore || holidayAfter)
//     ) {
//       setSandwichLeave(true);
//       dynamicMessage =
//         "Your leave qualifies as a sandwich leave due to public holidays connecting your leave.";
//     } else {
//       setSandwichLeave(false);
//       dynamicMessage = "Your leave does not qualify as a sandwich leave.";
//     }
//   }

//   setDynamicMessage(dynamicMessage);
// };

const checkForSandwichLeave = () => {
  const startDate = moment(fromDate, "MM/DD/YYYY");
  const endDate = moment(toDate, "MM/DD/YYYY");

  // Not a sandwich leave: no notice, and clear one left by an earlier pick
  const clearSandwich = () => {
    setSandwichLeave(false);
    setDynamicMessage("");
  };

  if (!startDate.isValid() || !endDate.isValid() || !endDate.isSameOrAfter(startDate, "day")) {
    return clearSandwich();
  }

  const leaveDays = endDate.diff(startDate, "days") + 1;
  if (leaveDays <= 1) return clearSandwich();

  // const isWorkingSaturday = isWorkingSaturday(date)

  // const isWeekend = (day) => day === 0 || (day === 6 && !isWorkingSaturday(moment().day(day)));
  const isWeekend = (date) =>
  date.day() === 0 || (date.day() === 6 && !isWorkingSaturday(date));


  // const getWeekendBetween = (start, end) => {
  //   let current = start.clone();
  //   let weekendDays = [];
  //   while (current.isSameOrBefore(end)) {
  //     if (isWeekend(current.day())) weekendDays.push(current.clone());
  //     current.add(1, "day");
  //   }
  //   return weekendDays;
  // };
  const getWeekendBetween = (start, end) => {
    let current = start.clone();
    let weekendDays = [];
  
    while (current.isSameOrBefore(end)) {
      if (isWeekend(current)) {
        weekendDays.push(current.clone());
      }
      current.add(1, "day");
    }
  
    return weekendDays;
  };
  

  const checkPublicHolidays = (start, end) => {
    const holidays = publicHolidayList.map(h => moment(h.date, "MM/DD/YYYY"));

    const holidaysInRange = holidays.filter(h => h.isBetween(start, end, "day", "[]") && !isWorkingSaturday(h));
    const holidayBefore = holidays.some(h => h.isSame(start.clone().subtract(1, "day"), "day"));
    const holidayAfter = holidays.some(h => h.isSame(end.clone().add(1, "day"), "day"));

    return { holidaysInRange, holidayBefore, holidayAfter };
  };

  const checkPastSandwichPatterns = () => {
    const rangeStart = moment().startOf("month").subtract(3, "months");
    const rangeEnd = moment().endOf("month");

    return leavetable
      .filter((leave) => leave.type === "Full day")
      .map((leave) => ({
        start: moment(leave.from, "MM/DD/YYYY"),
        end: leave.to ? moment(leave.to, "MM/DD/YYYY") : moment(leave.from, "MM/DD/YYYY"),
      }))
      .filter((leave) =>
        (leave.start.isBetween(rangeStart, rangeEnd, "day", "[]") || leave.end.isBetween(rangeStart, rangeEnd, "day", "[]")) &&
        getWeekendBetween(leave.start, leave.end).length >= 1
      );
  };

  // WEEKEND pattern (leave starts before and ends after weekend)
  const weekendsInLeave = getWeekendBetween(startDate, endDate);
  const isSandwich = weekendsInLeave.length > 0 &&
    startDate.day() <= 5 && endDate.day() >= 1;

  const pastPatterns = checkPastSandwichPatterns();
  const { holidaysInRange, holidayBefore, holidayAfter } = checkPublicHolidays(startDate, endDate);

  // Auto-adjust cases:
  // if (
  //   startDate.day() === 1 && // Monday
  //   moment(startDate).subtract(2, "days").day() === 6 && // Preceding Saturday
  //   moment(startDate).subtract(1, "days").day() === 0    // Preceding Sunday
  // ) {
  //   const newFrom = moment(startDate).subtract(2, "days");
  //   setfromDate(newFrom.toDate());
  //   settoDate(endDate.toDate());
  //   setSandwichLeave(true);

  //   const msg = `Your leave starts on a Monday following a weekend. Leave adjusted from ${newFrom.format("MM/DD/YYYY")} to ${endDate.format("MM/DD/YYYY")}.`;
  //   setDynamicMessage(msg);
  //   return Utils.toast("error", msg);
  // }
  if (startDate.day() === 1) { // Monday
    const saturday = moment(startDate).subtract(2, "days");
    const sunday = moment(startDate).subtract(1, "days");
  
    // Find the first Saturday of the month
    const isFirstSaturday = (() => {
      const firstDayOfMonth = saturday.clone().startOf("month");
      let firstSaturday = firstDayOfMonth.clone();
      while (firstSaturday.day() !== 6) {
        firstSaturday.add(1, "day");
      }
      return saturday.isSame(firstSaturday, "day");
    })();
  
    const leaveSpan = endDate.diff(startDate, "days") + 1;
  
    if (saturday.day() === 6 && sunday.day() === 0 && (leaveSpan >= 3 || !isFirstSaturday)) {
      const newFrom = isFirstSaturday ? sunday : saturday;
  
      setfromDate(newFrom.toDate());
      settoDate(endDate.toDate());
      setSandwichLeave(true);
  
      const msg = `Your leave starts on a Monday and has been adjusted ${
        isFirstSaturday ? 'from Sunday' : 'from Saturday'
      } to ${endDate.format("MM/DD/YYYY")} to include the preceding weekend.`;
  
      return setDynamicMessage(msg);
    }
  }
  
  // if (
  //   endDate.day() >= 3 && endDate.day() <= 5 && // Wed, Thu, Fri
  //   moment(endDate).add(1, "days").day() === 6 && // Saturday follows
  //   moment(endDate).add(2, "days").day() === 0    // Sunday follows
  // ) {
  //   const newTo = moment(endDate).add(2, "days");
  //   setfromDate(startDate.toDate());
  //   settoDate(newTo.toDate());
  //   setSandwichLeave(true);

  //   const msg = `Your leave ends just before a weekend. It has been extended to include Saturday and Sunday: ${startDate.format("MM/DD/YYYY")} to ${newTo.format("MM/DD/YYYY")}.`;
  //   setDynamicMessage(msg);
  //   return Utils.toast("error", msg);
  // }
  if (
    endDate.day() >= 3 && endDate.day() <= 5 // Wed, Thu, Fri
  ) {
    const saturday = moment(endDate).add(1, "days");
    const sunday = moment(endDate).add(2, "days");
  
    const isFirstSaturdayOfMonth = saturday.day() === 6 && saturday.date() <= 7;
  
    if (
      saturday.day() === 6 &&
      sunday.day() === 0 &&
      !isFirstSaturdayOfMonth //  ignore first Saturday
    ) {
      const newTo = sunday;
      setfromDate(startDate.toDate());
      settoDate(newTo.toDate());
      setSandwichLeave(true);
  
      const msg = `Your leave ends just before a weekend (excluding first-week Saturday). It has been extended to include Saturday and Sunday: ${startDate.format("MM/DD/YYYY")} to ${newTo.format("MM/DD/YYYY")}.`;
      return setDynamicMessage(msg);
    }
  }
  
  // Main Sandwich check
  if (isSandwich) {
    setSandwichLeave(true);
    const msg = `Your leave overlaps a weekend. ${leaveDays} days from ${startDate.format("MM/DD/YYYY")} to ${endDate.format("MM/DD/YYYY")} will be counted as sandwich leave.`;
    return setDynamicMessage(msg);
  }

  // Public holiday-based sandwich
  if (leaveDays >= 4 && holidaysInRange.length > 0 && (holidayBefore || holidayAfter)) {
    setSandwichLeave(true);
    const msg = "Your leave qualifies as a sandwich leave due to public holidays connecting your leave.";
    return setDynamicMessage(msg);
  }

  // Past Pattern Match - suggest possible sandwich
  if (pastPatterns.length > 0) {
    // setSandwichLeave(true);
    // const msg = `Your leave resembles a previous sandwich pattern from past 3 months. From ${startDate.format("MM/DD/YYYY")} to ${endDate.format("MM/DD/YYYY")} may be deducted.`;
    // setDynamicMessage(msg);
    // return Utils.toast("error", msg);
  }

  clearSandwich();

  // No sandwich pattern
  // setSandwichLeave(false);
  // const msg = "Your leave does not qualify as a sandwich leave.";
  // setDynamicMessage(msg);
};


  useEffect(() => {
  if (+type !== 1) {
    setSandwichLeave(false);
    setDynamicMessage("");
    setTakenShortLeave(false);
  }
}, [type]);


useEffect(() => {
  if (+type === 1) {
    checkForSandwichLeave();
  }
}, [type,fromDate,toDate]);


  return (
    <>
      <div className={props?.data?.transtion == true ? "contents" : "content"}>
        <div className="content-top-spacer"></div>
        <div className="color-body">
          <div className="page-head">
            <div className="page-eyebrow">People</div>
            <h1 className="page-title">Apply for Leave</h1>
          </div>
          <div className="row">
            <div className="col-md-6 manage">
              <div className="card-input mt-5 mb-2">
                <div className="col-md-12">
                  <div className="mt-3">
                    <h5 className="border-bottom pb-2">Apply for Leave</h5>
                  </div>
                  <form>
                    <div className="row mt-3">
                      {/* <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Department</label>
                          <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                            options={helperData?.departments}
                            // value={{label : departments?.label , value:departments?.value}}
                            onChange={(departments) => {
                              setdepartmentval(departments.value);
                              getDepartmentUsers(departments.value);
                              setEmployee(true);
                            }}
                            placeholder="Please Select"
                          />
                        </div>
                      </div> */}
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Leave Type</label>
                          <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                            options={helperData?.leave_type}
                            // value={{label : departments?.label , value:departments?.value}}
                            onChange={(leavetype) => {
                              settype(leavetype.value);
                              if (leavetype.value == "1") {
                                setHalf("");
                                setStartTime("");
                                setEndTime("");
                              }
                              if (leavetype.value == "2") {
                                setStartTime("");
                                setEndTime("");
                              }
                              if (leavetype.value == "3") {
                                setHalf("");
                              }
                            }}
                            placeholder="Please Select"
                          />
<FieldError msg={errors.type} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        {employee == true ? (
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Employee</label>
                            <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                              options={departmentEmployees}
                              // value={{label : departments?.label , value:departments?.value}}
                              onChange={(employe) => {
                                setEmployes(employe.value);
                                getRecentLeaves(employe.value);
                              }}
                              placeholder="Please Select"
                            />
                          </div>
                        ) : null}
                      </div>
                      {type == 1 || type == 2 || type == 3 ? (
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">
                              From Date
                            </label>
                            <DateField
                              value={fromDate}
                              onChange={(date) => {
                                setfromDate(date);
                              }}
                            />
                          </div>
                        </div>
                      ) : null}
                      {type == 1 ? (
                        <>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">
                                End Date
                              </label>

                              <DateField
                                value={toDate}
                                onChange={(date) => settoDate(date)}
                              />
                            </div>
                          </div>
                        </>
                      ) : null}
                      {type == 2 ? (
                        <>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Half</label>
                              <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                                options={helperData?.half_leave_type}
                                // value={{label : departments?.label , value:departments?.value}}
                                onChange={(element) => {
                                  setHalf(element.value);
                                }}
                                placeholder="Please Select"
                              />
                            </div>
                          </div>
                        </>
                      ) : null}
                      {type == 3 ? (
                        <>
                          <div className="col-md-3">
                            <label htmlFor="exampleInputEmail1">
                              Start Time
                            </label>
                            <TimeField
                              min="09:00:00"
                              max="20:00:00"
                              value={startTime}
                              onChange={(start) => {
                                setStartTime(start);
                                /* keep the pair valid: End Time follows when
                                   Start Time catches up with it */
                                if (!Utils.isTimeAfter(endtime, start)) {
                                  setEndTime(Utils.timeAddMinutes(start, 30));
                                }
                              }}
                              invalid={Boolean(errors.startTime)}
                            />
<FieldError msg={errors.startTime} />
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="exampleInputEmail1">End Time</label>
                            <TimeField
                              min="09:00:00"
                              max="20:00:00"
                              after={startTime}
                              value={endtime}
                              onChange={(end) => {
                                setEndTime(end);
                              }}
                            />
                          </div>
                        </>
                      ) : null}

                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Reason</label>
                          <textarea
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            onChange={(reason) => {
                              setReason(reason.target.value);
                            }}
                            rows="4"
                          ></textarea>
<FieldError msg={errors.reason} />
                        </div>
                        <div className="mt-2">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">
                              Contact During Leave
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={(Contact) => {
                                setcontact(Contact.target.value);
                              }}
                              // placeholder="Enter Project Name"
                            />
<FieldError msg={errors.contact} />
                          </div>
                        </div>
                      </div>
                    </div>
                    {hasAlreadyTakenShortLeave === true && (
                      <span className="shortLeaveErrror">
                        You can't apply for short leave more than 1 times in a
                        month.
                      </span>
                    )}
                    {/* Only when the dates make a sandwich leave; stays until the
                        dates change or it is dismissed. */}
                    <Banner
                      open={Boolean(dynamicMessage)}
                      status="warning"
                      contrast="high"
                      dismissible
                      onDismiss={() => setDynamicMessage("")}
                    >
                      <BannerTitle>Sandwich leave</BannerTitle>
                      <BannerDescription>{dynamicMessage}</BannerDescription>
                    </Banner>
                    {isAlreadyTakeSortLeave === true && (
                      <span className="shortLeaveErrror">
                        You have already applied for a short leave this month.
                      </span>
                    )}
                    <div className="col-md-12">
                      <div className="row mb-5 mt-4">
                        <div className="">
                          <LoadingButton
                            className={`${
                              hasAlreadyTakenShortLeave
                                ? "disabledBtn"
                                : "create-button"
                            }`}
                            successLabel="Applied"
                            onAction={AddLeave}
                            disabled={hasAlreadyTakenShortLeave}
                          >
                            Apply
                          </LoadingButton>
                        </div>
                        <div className="ml-2">
                          <button
                            type="button"
                            className="create-button1 btn-info"
                            onClick={() => navigate("/")}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-6 manage">
              <div className="card-input mt-5 mb-2">
                <div className="col-md-12">
                  <div className="mt-3">
                    <h5>My Recent Approved Leaves</h5>
                  </div>
                  <DataTable
                    columns={recentLeaveColumns}
                    data={leavetable || []}
                    pagination={false}
                    emptyText="No Recent Approved Leaves"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDeveloperLeave;
